import React, { useState, useMemo, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageUploadModal from "../../../../helpers/image-upload";
import { getToken } from "../../../../helpers/Jwt";
import axios from "axios";

const RichTextEditor = ({ onChange, value }) => {

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_IMAGE_TEMP = "api/kejati/dashboard/news/upload";
    const PATH_NEWS = "api/kejati/dashboard/news";

    const [content, setContent] = useState(value);
    const [imgValue, setImgValue] = useState("");
    const [openCropImage, setOpenCropImage] = useState(false);

    const handleChange = (value) => {
        setContent(value);
        if (onChange) {
            onChange(value);
        }
    };

    const handleFotoChange = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            setImgValue(reader.result);
            setOpenCropImage(true);
        };
        reader.readAsDataURL(file);
    };

    const closeModal = () => {
        setOpenCropImage(false);
    };

    const handleCropImage = async (croppedImage) => {
        setOpenCropImage(false);
        try {
            const response = await axios.post(`${BASE_URL}${PATH_IMAGE_TEMP}`, {
                'image': croppedImage
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getToken()}`
                }
            });


            const imgTag = `<img src="${BASE_URL}${response.data}" />`;
            setContent((prevContent) => prevContent + imgTag);
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };

    // const handleSubmit = async () => {
    //     if (content) {
    //         const response = await fetch(`${BASE_URL}${PATH_NEWS}`, {
    //             method: "POST",
    //             body: JSON.stringify({ content }),
    //             headers: { "Content-Type": "application/json" },
    //         });
    //         const data = await response.json();

    //         if (data.success) {
    //             console.log("Content with images successfully submitted.");
    //         } else {
    //             console.error("Error submitting content.");
    //         }
    //     }
    // };

    const modules = useMemo(() => ({
        toolbar: {
            container: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["image"],
            ],
            handlers: {
                image: function () {
                    const input = document.createElement("input");
                    input.setAttribute("type", "file");
                    input.setAttribute("accept", "image/*");
                    input.click();
                    input.onchange = handleFotoChange;
                },
            },
        },
    }), []);

    return (
        <div>
            <ReactQuill
                theme="snow"
                modules={modules}
                value={content}
                onChange={handleChange}
                className="bg-white"
            />
            <ImageUploadModal
                modalOpen={openCropImage}
                onClose={closeModal}
                fileOpen={imgValue}
                onCroped={handleCropImage}
                imgHeight={200}
                imgWidth={200}
                identifier="logo"
            />
            {/* <button onClick={handleSubmit} className="mt-4 p-2 bg-blue-500 text-white rounded">Submit</button> */}
        </div>
    );
};

export default RichTextEditor;